import * as React from 'react';

const NotFoundPage = () => (
    <div>
        <h2>404, Not Found!</h2>
    </div>
);

export default NotFoundPage;
